module.exports = __webpack_public_path__ + "static/media/settings.85bf09ef.png";